import _ from 'lodash'
import MobileDetect from 'mobile-detect'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  applicationCheckVersion,
  applicationCheckVersionInvalidVersion,
  applicationCheckVersionValidVersion,
} from 'core/actions'
import MESSAGES from 'core/data-model/constants/messages'
import values from 'core/data-model/constants/values'
import { getAppConfig } from 'deploy-env/app-config'
import { IsRealDevice } from 'e-submission/utils'
import {
  getUserAgentType,
  isAmloBlocked,
  isLoggedIn,
  isAllowIproMenu,
  isAllowReviseQQMenu,
  isAllowMwpMenu,
  getIdentityUser
} from 'identity/selectors'
import { resetQuoteForm, loginRequest, checkVersionAppUpdate } from 'quick-quote/actions'
import { ROUTE_PATH } from 'quick-quote/constants/path'
import { getToggles } from 'quick-quote/feature-toggles'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { getIsUserOnline } from 'quick-quote/selectors'

import { qqPath } from '../constants/path'

import { startFNAFlow, startQQFlow } from './actions'
import { TitlePortal } from './title-portal'
import { getAdvisor } from 'e-submission/domain/service'
import { evaluateAmloAccess, isAmloApplicable } from 'identity/amlo'

export const AMLO_EXEMPT_MENU_IDS = ['ekyc']
export const AMLO_EXEMPT_GROUP_IDS = ['additional']

export const PortalMenuConfigs = {
  az: {
    id: 'az',
    title: 'Advisor Zone',
    items: [
      {
        id: 'fna',
        title: MESSAGES.GO_TO_NEED_AND_GAP_ANALYSIS,
        path: ROUTE_PATH.NEED_AND_GAP_ANALYSIS,
        disabled: props => {
          const isWs = props.userAgentType === values.AGENT_TYPE_CS
          return isWs && !getToggles().ENABLE_CS_USERTYPE
        }
      },
      {
        id: 'calculate-premium',
        title: MESSAGES.GO_TO_QUICK_QUOTE,
        path: qqPath(ROUTE_PATH.PRODUCT_SELECTION),
        hide: props => props.allowReviseQQMenu,
        disabled: props => {
          const isWs = props.userAgentType === values.AGENT_TYPE_CS
          return isWs && !getToggles().ENABLE_CS_USERTYPE
        }
      },
      {
        id: 'policy-list',
        title: MESSAGES.GO_TO_POLICY_LIST,
        path: ROUTE_PATH.POLICY_LIST,
        disabled: props => {
          const isWs = props.userAgentType === values.AGENT_TYPE_CS
          return isWs && !getToggles().ENABLE_CS_USERTYPE
            ? true
            : props.disableHistory
        }
      }
    ]
  },
  prospect: {
    id: 'prospect',
    title: 'ข้อมูลผู้มุ่งหวัง (Prospect)',
    items: [
      {
        id: 'opty',
        title: MESSAGES.GO_TO_OPTY,
        path: ROUTE_PATH.OPTY,
        hide: props => props.hideOpty,
        loginRequired: props => props.loginRequired
      },
      {
        id: 'mw-plus',
        title: MESSAGES.GO_TO_MW_PLUS,
        path: ROUTE_PATH.MW_PLUS,
        hide: props => props.hideMwp,
        loginRequired: props => props.loginRequired
      }
    ]
  },
  additional: {
    id: 'additional',
    title: 'Additional / Other Services',
    items: [
      {
        id: 'calculate-premium',
        title: MESSAGES.GO_TO_REVISE_QUICK_QUOTE,
        path: qqPath(ROUTE_PATH.PRODUCT_SELECTION),
        hide: props => !props.allowReviseQQMenu
      },
      {
        id: 'ecbr',
        title: MESSAGES.GO_TO_ECBR,
        hide: props => !getToggles().ENABLE_ECBR_ON_PORTAL || props.hideEcbr
      },
      {
        id: 'ekyc',
        title: MESSAGES.GO_TO_EKYC,
        hide: props => !getToggles().ENABLE_EKYC_PORTAL || props.hideEkyc
      },
      {
        id: 'brochure',
        title: MESSAGES.GO_TO_BROCHURE,
        path: ROUTE_PATH.BROCHURE_LIST,
        hide: props => {
          const isAgentAndCs = _.includes(
            [values.AGENT_TYPE_CS, values.AGENT_TYPE_AGENT],
            props.userAgentType
          )
          return (
            !getToggles().ENABLE_BROCHURE || !isAgentAndCs || !props.isUserLogin
          )
        }
      }
    ]
  },
  tools: {
    id: 'tools',
    title: 'Sales tool',
    items: [
      {
        id: 'i-pro',
        isSaleFlow: true,
        externalUrl: `${getAppConfig().PORTAL_IPRO_URL}`
      },
      {
        id: 'my-wealth',
        isSaleFlow: true,
        externalUrl: `${getAppConfig().PORTAL_MY_WEALTH_URL}`,
        disabled: true
      }
    ]
  },
  privilege: {
    id: 'privilege',
    title: 'Privilege',
    items: [
      {
        id: 'privilege',
        title: MESSAGES.GO_TO_PRIVILEGE,
        isSaleFlow: true,
        externalUrl: `${getAppConfig().PORTAL_PRIVILEGE_URL}`
      }
    ]
  }
}

export const RenderMenuGroup = props => {
  const { id, title, items, hideEcbr, hideEkyc } = props
  const { history, startFNAFlow, startQQFlow } = props
  const hideTitleAdditional =
    title === 'Additional / Other Services' && hideEcbr && hideEkyc
  const handleMenuClick = item => {
    const { id, path } = item
    history.push(path)

    if (id === 'fna') {
      startFNAFlow()
    } else if (id === 'quick-quote' || id === 'calculate-premium') {
      startQQFlow()
    }

    if (id === 'ecbr') {
      if (window.cordova) {
        const ecbrWindow = window.cordova.InAppBrowser.open(
          getAppConfig().PORTAL_ECBR_URL + '?location=mobile',
          '_blank',
          'location=no,zoom=no'
        )

        ecbrWindow.addEventListener('loadstart', event => {
          if (event.url.indexOf('return-az') > 0) {
            ecbrWindow.close()
          }
        })
      } else {
        window.open(getAppConfig().PORTAL_ECBR_URL + '?location=web')
      }
    }

    if (id === 'ekyc') {
      if (window.cordova) {
        window.cordova.InAppBrowser.open(
          getAppConfig().EKYC_DASHBOARD_URL + '?location=mobile',
          '_blank',
          'location=no,zoom=no'
        )
      } else {
        window.open(getAppConfig().EKYC_DASHBOARD_URL + '?location=web')
      }
    }

    if (id === 'i-pro') {
      window.open(getAppConfig().PORTAL_IPRO_URL)
    }

    if (id === 'privilege') {
      window.open(getAppConfig().PORTAL_PRIVILEGE_URL)
    }
  }

  return items.length ? (
    <div className={`az-portal__group az-portal__group--${id}`}>
      <div className='az-portal__group__title'>
        <h2 className='az-portal__group__title-text'>
          {!hideTitleAdditional ? title : ''}
        </h2>
      </div>
      <div className='az-portal__group__content'>
        {items
          .filter(item => !item.hide || !item.hide(props))
          .map(item => {
            const disabled =
              (item.disabled && item.disabled(props)) ||
              (Boolean(props.amloBlocked) &&
                !AMLO_EXEMPT_GROUP_IDS.includes(id) &&
                !AMLO_EXEMPT_MENU_IDS.includes(item.id))
            return (
              <button
                key={item.id}
                disabled={disabled}
                data-id={item.id}
                onClick={() => handleMenuClick(item)}
              >
                <span className={id === 'tools' ? item.id : 'button-container'}>
                  <span className={id === 'tools' ? '' : 'title-text'}>
                    {item.title}
                  </span>
                </span>
              </button>
            )
          })}
      </div>
    </div>
  ) : null
}

export const AmloBlockedBanner = () => (
  <div
    className='az-portal__amlo-banner'
    data-testid='amlo-blocked-banner'
    role='alert'
  >
    <span className='az-portal__amlo-banner__icon'>✗</span>
    <span className='az-portal__amlo-banner__text'>
      {MESSAGES.AMLO_BLOCKED_MESSAGE}
    </span>
  </div>
)

export const PortalMenu = props => {
  const isHideProspect = props.hideOpty && props.hideMwp
  const [isAmloInActive, setAmloInActive] = useState(false)
  const menulist = _.filter(
    PortalMenuConfigs,
    menu =>
      menu.id === 'az' ||
      menu.id === 'additional' ||
      (menu.id === 'prospect' && !isHideProspect)
  )
  const agentCode = props.agentCode

  useEffect(() => {
    const agentType = props.agentType
    if (agentCode && isAmloApplicable(agentType)) {
      getAdvisor(props.user, agentCode, agentType).then(advisor => {
        const result = evaluateAmloAccess({ advisor })
        setAmloInActive(!result.hasAccess)
      })
    }
  }, [agentCode])

  useEffect(() => {
    props.resetQuoteForm()
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const azMWMinVersion = _.get(userInfo, 'azMWMinVersion', null)
    if (getToggles().ENABLE_CHECK_TARGET_VERSION && IsRealDevice && azMWMinVersion) {
      props.applicationCheckVersion()
    }
  }, [])

  return (
    <div className='az-portal'>
      <TitlePortal />
      {isAmloInActive && <AmloBlockedBanner />}
      <div className='az-portal__content'>
        {menulist.map((menu, index) => (
          <RenderMenuGroup
            key={index}
            {...menu}
            {...props}
            amloBlocked={isAmloInActive}
          />
        ))}
      </div>
    </div>
  )
}

PortalMenu.propTypes = {
  startQQFlow: PropTypes.func,
  startFNAFlow: PropTypes.func
}
PortalMenu.defaultProps = {
  startQQFlow () {},
  startFNAFlow () {}
}

const mapStateToProps = state => {
  const userAgentType = getUserAgentType(state)
  const user = getIdentityUser(state)
  const agentCode = _.get(user, 'profile.agent_code')
  const agentType = _.get(user, 'profile.agent_type')
  const isLb = userAgentType === values.AGENT_TYPE_LB
  const isFSE = userAgentType === values.AGENT_TYPE_FSE
  const isBA = userAgentType === values.AGENT_TYPE_BANCA
  const mobileDetect = new MobileDetect(window.navigator.userAgent)
  const isDesktop = !mobileDetect.mobile() && !mobileDetect.tablet()

  const isWS = userAgentType === values.AGENT_TYPE_CS

  let hideHistory = false
  if (isWS) {
    if (!getToggles().ENABLE_CS_USERTYPE) {
      hideHistory = true
    }
  } else if (isLb) {
    if (getToggles().ENABLE_BANCA_BLOCK_ESUB_WEB_VIEW) {
      hideHistory = !IsRealDevice
    } else if (getToggles().DISABLE_HISTORY_FOR_LB) {
      hideHistory = isDesktop
    }
  } else if (isFSE || isBA) {
    hideHistory = true
  }

  const hideEcbr =
    !isLoggedIn(state) ||
    !getAppConfig().ALLOWED_ECBR_MENU.includes(userAgentType)

  const hideEkyc =
    !isLoggedIn(state) ||
    !getAppConfig().ALLOWED_EKYC_MENU.includes(userAgentType)
  let hideRemoteSelling = true
  if (getToggles().ENABLE_APPMAN_REMOTE_SELLING && !hideEkyc) {
    if (getToggles().ENABLE_SHOW_REMOTESELLING_ONWEB) {
      hideRemoteSelling = false
    } else {
      hideRemoteSelling = !IsRealDevice
    }
  }

  const hideOpty = !isAllowIproMenu(state)
  const hideMwp = !isAllowMwpMenu(state)
  const allowReviseQQMenu = isAllowReviseQQMenu(state)
  const disableHistory = hideHistory
  const isUserLogin = isLoggedIn(state)
  const isUserOnline = getIsUserOnline(state)
  const loginRequired = !isLoggedIn(state)
  const amloBlocked = isAmloBlocked(state)

  return {
    hideHistory,
    hideEcbr,
    hideEkyc,
    disableHistory,
    isUserLogin,
    isUserOnline,
    loginRequired,
    hideRemoteSelling,
    userAgentType,
    hideOpty,
    hideMwp,
    allowReviseQQMenu,
    amloBlocked,
    user,
    agentCode,
    agentType
  }
}

const mapDispatchToProps = dispatch => {
  return {
    startQQFlow: bindActionCreators(startQQFlow, dispatch),
    startFNAFlow: bindActionCreators(startFNAFlow, dispatch),
    resetQuoteForm: bindActionCreators(resetQuoteForm, dispatch),
    needLogin: bindActionCreators(loginRequest, dispatch),
    setNotification: bindActionCreators(setNotificationMessage, dispatch),
    loginRequest: bindActionCreators(loginRequest, dispatch),
    checkVersionAppUpdate: bindActionCreators(checkVersionAppUpdate, dispatch),
    applicationCheckVersion: bindActionCreators(
      applicationCheckVersion,
      dispatch
    ),
    applicationCheckVersionValidVersion: bindActionCreators(
      applicationCheckVersionValidVersion,
      dispatch
    ),
    applicationCheckVersionInvalidVersion: bindActionCreators(
      applicationCheckVersionInvalidVersion,
      dispatch
    )
  }
}

export const PortalContainer = connect(mapStateToProps, mapDispatchToProps)(PortalMenu)

export default PortalContainer
